import { loadScript } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { getAttributeValue } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/** @param {Element} node */
function getParentTopNodeName(node) {
  switch (node.nodeName) {
    case 'HEAD':
    case 'BODY':
      return node.nodeName;

    default:
      return getParentTopNodeName(node.parentNode);
  }
}

/** @param {Element} node */
function getScriptPriority(node) {
  const parentTopNodeName = getParentTopNodeName(node.parentNode);

  switch (parentTopNodeName) {
    case 'HEAD': {
      const src = getAttributeValue(node, 'src');

      if (!src) {
        return 1;
      }

      const async = getAttributeValue(node, 'async');

      if (async !== undefined) {
        return 10;
      }

      const defer =
        getAttributeValue(node, 'defer') !== undefined ||
        getAttributeValue(node, 'type') === 'module';

      return defer ? 1 : 0;
    }

    case 'BODY': {
      const src = getAttributeValue(node, 'src');

      if (!src) {
        return 5;
      }

      const async = getAttributeValue(node, 'async');

      if (async !== undefined) {
        return 10;
      }

      const defer =
        getAttributeValue(node, 'defer') !== undefined ||
        getAttributeValue(node, 'type') === 'module';

      return defer ? 4 : 3;
    }

    default:
      return 6;
  }
}

/**
 * @param {AssetLoader} assetLoader
 */
function processScripts(assetLoader) {
  return {
    selector: 'script:not([type="application/json"])',
    remove: true,
    /** @param {Element} node */
    processNode(node) {
      const loader = loadScript({
        src: getAttributeValue(node, 'src'),
        content: node.innerHTML,
        type: getAttributeValue(node, 'type'),
        defer: getAttributeValue(node, 'defer'),
        async: getAttributeValue(node, 'async'),
      });

      if (loader) {
        assetLoader.addScript(loader, 'content', getScriptPriority(node), {
          defer: getAttributeValue(node, 'defer'),
        });
      }
    },
  };
}

export default processScripts;
